import api from './api';
import { getSocket } from './realtimeService';

export interface StartCallResponse {
  meetLink: string;
  eventId?: string;
  htmlLink?: string;
  isConference?: boolean;
  invitedUserIds?: string[];
}

/**
 * Połączenie 1‑na‑1 — legacy API; backend dalej akceptuje target_user_id.
 */
export async function startCall(targetUserId: string): Promise<StartCallResponse> {
  return startCallRequest({ target_user_id: targetUserId });
}

/**
 * Telekonferencja — wysyła zaproszenia do wielu osób na ten sam link Meet.
 * Lista jest deduplikowana po stronie backendu, ale czyścimy ją też tutaj,
 * żeby uniknąć niepotrzebnego payloadu.
 */
export async function startConferenceCall(targetUserIds: string[]): Promise<StartCallResponse> {
  const ids = Array.from(new Set((targetUserIds || []).map((s) => String(s || '').trim()).filter(Boolean)));
  if (ids.length === 0) throw new Error('Wybierz przynajmniej jednego uczestnika telekonferencji');
  return startCallRequest({ target_user_ids: ids });
}

async function startCallRequest(body: { target_user_id?: string; target_user_ids?: string[] }): Promise<StartCallResponse> {
  try {
    const res = await api.post('/calls/start', body);
    if (!res?.data?.success) throw new Error(res?.data?.message || 'Nie udało się zainicjować połączenia');
    const { meetLink, eventId, htmlLink, isConference, invitedUserIds } = res.data.data || {};
    if (!meetLink) throw new Error('Brak linku do spotkania');
    return { meetLink, eventId, htmlLink, isConference: !!isConference, invitedUserIds: invitedUserIds || [] };
  } catch (e: any) {
    const status = e?.response?.status;
    const requireReauth = e?.response?.data?.requireReauth;
    const base = (api as any).defaults?.baseURL || '';
    const authUrl = `${base}/auth/google?prompt=consent`;
    if ((status === 401 || status === 403) && requireReauth) {
      window.location.href = authUrl;
      return Promise.reject(e);
    }
    throw e;
  }
}

export type IncomingCallHandler = (payload: {
  fromUserId: string;
  fromDisplayName?: string | null;
  fromAvatarUrl?: string | null;
  meetLink: string;
  toUserId?: string;
  /** Telekonferencja – więcej niż jeden zaproszony. */
  isConference?: boolean;
  /** Lista wszystkich zaproszonych user_id (bez dzwoniącego). */
  participantUserIds?: string[];
  /** Liczba uczestników razem z dzwoniącym. */
  participantsCount?: number;
}) => void;

export function onIncomingCall(handler: IncomingCallHandler) {
  const s = getSocket();
  s.on('call:incoming', handler as any);
  return () => s.off('call:incoming', handler as any);
}
